module.exports = __webpack_public_path__ + "static/media/ballot-check.63c7be4c.svg";